import { IAddProduct } from '../../models/forms/IAddUpdateProduct';
const initialProductState: IAddProduct = {
  TenantId: -1,
  ProductName: '',
  TraySize: '',
  KeyInfo1: '',
  KeyInfo2: '',
  KeyInfo3: '',
  Remarks: '',
  Process: [],
  ProcessTemplate: '-1',
  ProductFiles: [],
  ProductFilesInfo: [],
  ProductTeplars: [],
  ProcessOption: '-1',
  Customer: '',
  Katashiki: '',
  CommonProcess: [],
  DimensionData: [],
  SelectedProcessForDimensionTable: -1,
  Dimension: {
    SelectedColumns: [],
    TableData: [],
  },
  UpdatedOn: '',
  CreatedOn: '',
  SelectedCheckItemTemplateId: -1,
  IsImport: false,
};

export default initialProductState;
